export default "./../../assets/images/test.png";